'use client';

import {createContext, useContext, useState, useCallback, type ReactNode} from 'react';

interface AuthDialogContextType {
	isOpen: boolean;
	openDialog: () => void;
	closeDialog: () => void;
	setDialog: (value: boolean) => void;
}

const AuthDialogContext = createContext<AuthDialogContextType | undefined>(undefined);

export function AuthDialogProvider({children}: {children: ReactNode}) {
	const [isOpen, setIsOpen] = useState(false);

	const openDialog = useCallback(() => {
		setIsOpen(true);
	}, []);

	const closeDialog = useCallback(() => {
		setIsOpen(false);
	}, []);

	const setDialog = useCallback((value: boolean) => {
		setIsOpen(value);
	}, []);

	return (
		<AuthDialogContext.Provider
			value={{
				isOpen,
				openDialog,
				closeDialog,
				setDialog,
			}}
		>
			{children}
		</AuthDialogContext.Provider>
	);
}

export function useAuthDialog() {
	const context = useContext(AuthDialogContext);

	if (context === undefined) {
		throw new Error('useAuthDialog must be used within an AuthDialogProvider');
	}

	return context;
}
